/**
 * Pricing constants for subscription plans
 * - starter / maker: USD (Airwallex one-time payment)
 * - plus / plus_pro: CNY (Jeepay / Stripe)
 */
export const SUBSCRIPTION_PRICES = {
  plus: {
    monthly: 24.9,
    yearly: 19.9,
    yearlyTotal: 238.8,
    currency: 'CNY',
    symbol: '￥',
  },
  plus_pro: {
    monthly: 49.9,
    yearly: 39.9,
    yearlyTotal: 478.8,
    currency: 'CNY',
    symbol: '￥',
  },
  starter: {
    monthly: 24.9,
    yearly: 24.9,
    yearlyTotal: 298.8,
    currency: 'USD',
    symbol: '$',
  },
  maker: {
    monthly: 49.9,
    yearly: 49.9,
    yearlyTotal: 598.8,
    currency: 'USD',
    symbol: '$',
  },
} as const;

/**
 * Get the base monthly price for a plan (rounded down for discount calculations)
 */
export const getBaseMonthlyPrice = (plan: keyof typeof SUBSCRIPTION_PRICES): number => {
  return Math.floor(SUBSCRIPTION_PRICES[plan].monthly);
};
